import PolicyFinancialInstitution from './PolicyFinancialInstitution'

export default PolicyFinancialInstitution
